const map = {
	"./andrei.jpg": 5969,
	"./attila.jpg": 7267,
	"./bohdan.jpg": 7656,
	"./diana.jpg": 1899,
	"./dmitrii.jpg": 3348,
	"./elen.jpg": 2762,
	"./jhovet.jpg": 4830,
	"./king.jpg": 1801,
	"./lilibeth.jpg": 207,
	"./mark.jpg": 7523,
	"./roquiya.jpg": 5296,
	"./veronika.jpg": 717,
	"./zahra.jpg": 740
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5051;